import { Component, OnDestroy, OnInit } from '@angular/core';
import { BlockUiService } from '../app-shared-elements/_services/auto-block-ui.service';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { ConfigurationState } from '../app-shared-elements/_store/states/configuration.state';
import { Observable, Subject } from 'rxjs';
import { ConfigurationServerInterface } from '../app-shared-elements/_interfaces/configuration-server.interface';
import { ServerNamesEnum } from '../app-shared-elements/_enums/server-names.enum';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss'],
    standalone: false,
})
export class AuthComponent implements OnInit, OnDestroy {
    configurationServer$: Observable<ConfigurationServerInterface> = this.store.select(ConfigurationState.getConfigurationServer);

    readonly LOGO_USER_ICON_PATH = './assets/design/icons/auth-logo-user.svg';
    readonly LOGO_USER_CCC_ICON_PATH = './assets/design/icons/auth-logo-user-ccc.svg';
    readonly LOGO_ADMIN_ICON_PATH = './assets/design/icons/auth-logo-admin.svg';
    readonly LOGO_ADMIN_CCC_PATH = './assets/design/icons/nav/logo-admin-ccc.svg';

    serverNamesEnum = ServerNamesEnum;

    destroy: Subject<boolean> = new Subject<boolean>();

    constructor(
        private blockUiService: BlockUiService,
        public router: Router,
        private store: Store,
    ) {
        this.configurationServer$.pipe(takeUntil(this.destroy)).subscribe((configurationServer) => {
            if (!configurationServer) {
                return;
            }

            if (this.router.url.includes('control')) {
                const favicon = document.querySelector('link[rel="icon"]');
                const configurationServer = this.store.selectSnapshot(ConfigurationState.getConfigurationServer);
                favicon.setAttribute('href', `${configurationServer?.serverName === ServerNamesEnum.CCC ? 'assets/design/icons/admin-ccc.ico' : 'assets/design/icons/admin-sc.ico'}`);
            }
        });
    }

    ngOnInit(): void {
        this.blockUiService.clear();
    }

    ngOnDestroy(): void {
        this.destroy.next(true);
        this.destroy.complete();
    }
}
